import { render, staticRenderFns } from "./RoomList.vue?vue&type=template&id=31d07da1&lang=pug&"
import script from "./RoomList.vue?vue&type=script&lang=ts&"
export * from "./RoomList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomList.vue"
export default component.exports